import { InstrumentationKey, CloudRoleName, SkioldDigitalApiBaseUrl } from 'shared/constants';
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

type PropertyCollection = { [name: string]: string | undefined };

const appInsights = new ApplicationInsights({
    config: {
        loggingLevelTelemetry: 2,
        connectionString: 'InstrumentationKey=' + InstrumentationKey,
    }
});
const telemetryInitializer = (envelope: ITelemetryItem) => {
    if (envelope && envelope.tags) {
        envelope.tags["ai.cloud.role"] = CloudRoleName;
        envelope.tags["ai.cloud.roleInstance"] = SkioldDigitalApiBaseUrl;
    }
}
appInsights.loadAppInsights();
appInsights.addTelemetryInitializer(telemetryInitializer);
appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

export class Monitoring {
    public static logException(exception: Error) {
        console.error(exception);
        appInsights.trackException({ exception: exception });
    }

    public static logTrace(message: string, properties?: PropertyCollection) {
        console.warn(message);
        appInsights.trackTrace({ message }, properties);
    }

    public static logTraceCiva(site: string | undefined, message: string, properties?: PropertyCollection) {
        if (site === "682c7d84361a139d15369c19") {
            appInsights.trackTrace({ message }, properties);
        }
    }
}
